import { render, staticRenderFns } from "./balanceTable.vue?vue&type=template&id=37bdb66e&scoped=true&"
import script from "./balanceTable.vue?vue&type=script&lang=js&"
export * from "./balanceTable.vue?vue&type=script&lang=js&"
import style0 from "./balanceTable.vue?vue&type=style&index=0&id=37bdb66e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bdb66e",
  null
  
)

export default component.exports